import { render, staticRenderFns } from "./base-slider.vue?vue&type=template&id=2c52f402&scoped=true&"
import script from "./base-slider.vue?vue&type=script&lang=js&"
export * from "./base-slider.vue?vue&type=script&lang=js&"
import style0 from "./base-slider.vue?vue&type=style&index=0&id=2c52f402&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c52f402",
  null
  
)

export default component.exports